export default __webpack_public_path__ + "static/media/694.0ebf8af5.gif";